module.exports = __webpack_public_path__ + "static/media/inventory icon 2.4da6dfaa.png";